import * as React from "react";
import Floor from "../models/Floor";
import { useState } from "react";
import CabinetSelection from "../components/CabinetSelection";
import BaseModel from "../models/BaseModel";
import { useOnChangeWatcher } from "../models/useOnChangeWatcher";
import BaseObject from "../models/BaseObject";
import PropertyViewHeader from "./PropertyViewHeader";
import BaseDialog from "../modelDialogs/BaseDialog";
import { itx } from "../translationItx/itx";
import { ConnectionType } from "../models/Connection";
import type Room from "../models/Room";

export default function FloorPropertyView(props: { obj: BaseModel; setPinned: (pinned: boolean) => void }) {
  const { obj, setPinned } = props;

  const floor = obj as Floor;
  const generalRoom = state.projectMetadata.isC1Project || floor.c1
    ? floor.rooms.findFirst(room => room.isFloorGeneralRoom)
    : floor.getRoomGeneral();

  const [cabinetId, setCabinetId] = useState(floor?.cabinetId || "");

  useOnChangeWatcher(state.cabinets, (changedObject: BaseObject, changedProperty: string | any | undefined) => {
    if (floor.waitForNewCabinet && changedProperty.className == "BaseModelMap") {
      const id = state.cabinets.asArray()[state.cabinets.size - 1].id;
      setCabinetId(id);
      floor.cabinetId = id;
      floor.waitForNewCabinet = false;
    }

    return true;
  });

  async function changeConsumerActorConnection() {
    if (floor.cabinet) {
      for (let [key, consumer] of generalRoom?.consumers.items ?? []) {
        const todeleteConnection = consumer.connections.asArray().filter((con) => {
          return con.type == ConnectionType.Channel;
        });
        todeleteConnection.forEach((con) => con.delete());
        const createdObjects = floor.cabinet.autoConnectChannel(floor.getOrCreatePage(), consumer, consumer.isDali);
        createdObjects.forEach((createdObj) => {});
      }
    }

    for (let [key, room] of floor.rooms.items) {
      if (floor.cabinet && room.cabinetId == "" && !room.isFloorGeneralRoom) {
        for (let [key, consumer] of room.consumers.items) {
          const todeleteConnection = consumer.connections.asArray().filter((con) => {
            return con.type == ConnectionType.Channel;
          });
          todeleteConnection.forEach((con) => con.delete());
          const createdObjects = floor.cabinet.autoConnectChannel(room.getOrCreatePage(), consumer, consumer.isDali);
          createdObjects.forEach((createdObj) => {});
        }
      }
    }
    state.selectionManager.selectedObject = floor;
  }

  function AskIfConsumerActorConnectionShouldBeInNewCabinet(props: {}) {
    return (
      <BaseDialog
        onOk={() => {
          changeConsumerActorConnection();
          return true;
        }}
        title={itx("roomPropertyView.newCabinetConnection", "Neuen Schaltschrank verbinden")}
      >
        <div>
          {itx(
            "roomPropertyView.channelConnectionsToOldCabinet",
            "Alle Verbindungen zum aktuellen Schaltschrank werden getrennt.",
          )}
          <br />

          {itx(
            "roomPropertyView.shouldNewConnectionsBeCreated",
            "Es werden neue Verbindungen mit dem neuen Schaltschrank erstellt.",
          )}
        </div>
      </BaseDialog>
    );
  }

  return (
    <div key={obj.id} className="App PropertyView">
      <PropertyViewHeader obj={obj} />

      <div style={{ padding: "10px", display: "flex", flexDirection: "row", justifyContent: "center" }}>
        {state.translate("components.Cabinet", "Schaltschrank")}
        &nbsp;
        <CabinetSelection
          floorRoom={floor}
          value={cabinetId}
          onChange={(id) => {
            const oldCabinet = floor.cabinet;
            setCabinetId(id);
            floor.cabinetId = id;
            if (oldCabinet != floor.cabinet) {
              state.dialogManager.openDialog(<AskIfConsumerActorConnectionShouldBeInNewCabinet />);
            }
          }}
          onChangeAfterCreation={() => {
            state.dialogManager.openDialog(<AskIfConsumerActorConnectionShouldBeInNewCabinet />);
            return false;
          }}
          fromProeprtyView={true}
        ></CabinetSelection>
      </div>
    </div>
  );
}
